import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { Observable } from "rxjs";

import {
  ContactModalComponent,
  ContactModalData,
  ContactModalFormData,
} from "@shared/components/contact-modal/contact-modal.component";
import { BaseModalService } from "@shared/services/base-modal.service";

@Injectable({
  providedIn: "root",
})
export class ContactModalService extends BaseModalService<
  ContactModalComponent,
  ContactModalFormData
> {
  constructor() {
    super(inject(MatDialog));
  }

  protected getDefaultConfig(): MatDialogConfig {
    return {
      width: "476px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      disableClose: false,
      autoFocus: true,
      restoreFocus: true,
    };
  }

  open(
    data: ContactModalData,
    config?: MatDialogConfig,
  ): Observable<ContactModalFormData | null | undefined> {
    return this.openModal(ContactModalComponent, data, config);
  }

  openAddContact(
    config?: MatDialogConfig,
  ): Observable<ContactModalFormData | null | undefined> {
    return this.open(
      {
        title: "Add New Contact",
        saveButtonText: "Save and Continue",
        cancelButtonText: "Cancel",
        isEditMode: false,
      },
      config,
    );
  }

  openEditContact(
    contact: ContactModalFormData,
    config?: MatDialogConfig,
  ): Observable<ContactModalFormData | null | undefined> {
    return this.open(
      {
        title: "Edit Contact",
        saveButtonText: "Save Changes",
        cancelButtonText: "Cancel",
        initialData: contact,
        isEditMode: true,
      },
      config,
    );
  }
}
